import { HttpClient, HttpContext } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { Observable, Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { BypassErrorHandling, BypassErrorToast } from '../../helpers/http-context-tokens'

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  private _http = inject(HttpClient)
  // to notify the navbar that the balance has changed as balance is changed when we do a payemnt
  public BalanceChanged = new Subject<boolean>()
  // to trigger balance refresh from other components
  public triggerBalanceRefresh = new Subject<void>()

  getBalance(workspaceId: string): Observable<number> {
    // Add cache-busting timestamp to ensure fresh data
    const timestamp = new Date().getTime()
    return this._http
      .get(`${environment.v2.baseUrl}plan/contactless/organizations/${workspaceId}/get-balance?t=${timestamp}`, {
        context: new HttpContext().set(BypassErrorHandling, true).set(BypassErrorToast, true)
      })
      .pipe(map((balance: { current_balance: number }) => balance.current_balance))
  }

  /**
   * Triggers a balance refresh in the navbar
   */
  refreshBalance(): void {
    this.triggerBalanceRefresh.next()
  }
}
